module.exports = __webpack_public_path__ + "img/réalisation escalier avec garde-corps inox.95146bd2.jpg";